var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { store as mainStore } from '../App';
import History, { toParentPath } from 'helpers/History';
import { t, T } from 'helpers/i18n';
import { Validation } from 'helpers/Validation';
import { mapValues, objectValues } from 'helpers/Utils';
import { Button, Field, FieldType } from 'elements';
var FormStretch = /** @class */ (function (_super) {
    __extends(FormStretch, _super);
    function FormStretch(props) {
        var _this = _super.call(this, props) || this;
        _this.priceFields = [];
        _this.stretchSchema = {};
        _this.state = {
            values: {},
            pricesValues: {},
            showHora: false
        };
        _this.mapNameId = {};
        _this.onChange = function (event) {
            console.log('event', event);
        };
        _this.handleChange = function (name, value, column) {
            var _a;
            // console.log('handleChange: ', `name: ${name} value: ${value} column: ${column}`)
            _this.setState({ values: __assign(__assign({}, _this.state.values), (_a = {}, _a[column ? column : name] = value, _a)) }, function () {
                console.log('handleChange: state.value', _this.state.values);
            });
            console.log('name', name);
            console.log('value', value);
            console.log('column', column);
            if (name === 'tramoHora') {
                _this.setState({ showHora: value });
            }
        };
        _this.handleChangePrices = function (name, value) {
            var _a;
            // console.log('handleChange: ', `name: ${name} value: ${value}`)
            _this.setState({ pricesValues: __assign(__assign({}, _this.state.pricesValues), (_a = {}, _a[name] = value, _a)) }, function () {
                // console.log('handleChangePrices: state.values', this.state.values)
            });
        };
        _this.handleCancel = function () {
            // console.log('handleCancel')
            var onCancel = _this.props.onCancel;
            if (onCancel)
                return onCancel();
            toParentPath();
        };
        _this.handleDisable = function (disable) { return function () {
            // console.log('handleDisable')
            var _a = _this.props, values = _a.values, store = _a.store, onDisable = _a.onDisable;
            var accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (onDisable)
                    return onDisable(disable);
                if (store && store.disable && values) {
                    store.disable(values.id, disable).then(toParentPath);
                }
            }
        }; };
        _this.handleDelete = function () {
            /*console.log('handleDelete')
            const {values, store, onDelete} = this.props
        
            const accept = confirm(t('confirmDelete'))
            if (accept) {
              if (onDelete) return onDelete()
              if (store && store.delete && values) {
                store.delete(values.id).then(toParentPath)
              }
            }*/
        };
        _this.handleReset = function () {
            // console.log('handleReset')
            _this.setState({ values: _this.parsedValues(), pricesValues: _this.parsedPricesValues(_this.props) });
        };
        _this.changeToId = function (stretchPrices) {
            console.log('changeToId');
            var result = {};
            var pricesValues = _this.state.pricesValues;
            for (var item in stretchPrices) {
                if (stretchPrices.hasOwnProperty(item)) {
                    // console.log('changeToId - item', item)
                    result[_this.mapNameId[item]] = pricesValues[item];
                }
            }
            // return stretchPrices
            return result;
        };
        _this.handleSubmit = function () {
            // console.log('handleSubmit - priceFields_', this.props.priceFields)
            var _a = _this.props, fields = _a.fields, propsValues = _a.values, store = _a.store, onSubmit = _a.onSubmit;
            var values = __assign({}, _this.state.values);
            var pricesValues = _this.state.pricesValues;
            // console.log('handleSubmit - values', values)
            // console.log('handleSubmit - pricesValues', pricesValues)
            // console.log('handleSubmit - schema', this.schema)
            // console.log('handleSubmit - stretchSchema', this.stretchSchema)
            var validation = new Validation(values, _this.schema);
            var stretchValidation = new Validation(pricesValues, _this.stretchSchema);
            console.log('validation.valid', validation.valid);
            console.log('validation', validation);
            console.log('stretchValidation.valid', stretchValidation.valid);
            console.log('stretchValidation', stretchValidation);
            if (validation.valid && stretchValidation.valid) {
                // Remove unmodified value
                _this.fields.map(function (field) {
                    // console.log(' values[field.column? field.column: field.name]',  values[field.column? field.column: field.name])
                    // console.log(' propsValues[field.column? field.column: field.name]',  propsValues[field.column? field.column: field.name])
                    if (propsValues && values[field.column ? field.column : field.name] === propsValues[field.column ? field.column : field.name]) {
                        delete values[field.column ? field.column : field.name];
                    }
                });
                /*console.log('propsValues', propsValues)*/
                var propsPriceValues_1 = _this.parsedPricesValues(propsValues);
                _this.priceFields.map(function (field) {
                    // console.log('pricesValues[field.name]', pricesValues[field.name])
                    // console.log('propsValues[field.name]', propsPriceValues[field.name])
                    if (propsPriceValues_1 && pricesValues[field.name] === propsPriceValues_1[field.name]) {
                        delete pricesValues[field.name];
                    }
                });
                // console.log('pricesValues', pricesValues)
                if (Object.keys(values).length === 0 && Object.keys(pricesValues).length === 0)
                    return mainStore.UI.newWarning(T('nothingModified'));
                // Convert empty strings to null
                values = mapValues(values, function (value) { return (value === '' ? null : value); });
                pricesValues = mapValues(pricesValues, function (value) { return (value === '' ? null : value); });
                // Use FormData instead of JSON if there is a image in value
                var data_1;
                if (Object.keys(_this.schema).includes('image')) {
                    // console.log('handleSubmit - image')
                    data_1 = new FormData();
                    Object.keys(values).forEach(function (key) {
                        if (values[key])
                            data_1.append(key, values[key]);
                    });
                }
                else {
                    data_1 = {
                    /*values: values,
                    stretchValues: this.changeToId(pricesValues)*/
                    };
                    if (pricesValues) {
                        data_1.stretchValues = _this.changeToId(pricesValues);
                    }
                    data_1.values = values;
                }
                // console.log('handleSubmit - data', data)
                // console.log('handleSubmit - propsValues', propsValues)
                if (onSubmit)
                    return onSubmit(data_1);
                // console.log('!onSubmit')
                if (store && data_1) {
                    var request = void 0;
                    if (propsValues) {
                        request = store.update(propsValues.id, data_1);
                    }
                    else {
                        request = store.create(data_1);
                    }
                    request.then(toParentPath);
                }
                else {
                    mainStore.UI.newWarning('error indefinido');
                }
            }
            else { // error en la validacion
                // console.log('FormStretch -handleSubmit - !validation.valid', validation)
                // console.log('handleSubmit - !stretchValidation.valid', stretchValidation)
                if (!validation.valid)
                    mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
                if (!stretchValidation.valid)
                    mainStore.UI.newWarning(objectValues(stretchValidation.errors).join('\n'));
            }
        };
        _this.fields = props.fields.filter(function (field) { return field; });
        console.log('FormStretch - constructor - this.fields: ', _this.fields);
        _this.schema = _this.fields.reduce(function (previous, _a) {
            var name = _a.name, rules = _a.rules, column = _a.column;
            previous[column ? column : name] = rules;
            return previous;
        }, {});
        if (props.priceFields) { // hay passengerCategories en el sistema
            _this.priceFields = props.priceFields.filter(function (field) { return field; });
            _this.stretchSchema = _this.priceFields.reduce(function (previous, _a) {
                var name = _a.name, rules = _a.rules;
                previous[name] = rules;
                return previous;
            }, {});
            _this.priceFields.forEach(function (priceField) {
                _this.mapNameId[priceField.name] = priceField.id;
            });
        }
        var tramoHora = _this.fields.filter(function (value) { return value.name === 'tramoHora'; })[0];
        // console.log('FormStretch - constructor - tramoHora: ', tramoHora)
        console.log('FormStretch - constructor - props.values: ', props.values);
        _this.state.showHora = _this.props.values !== undefined ? _this.props.values.tramoHora : tramoHora.defaultValue;
        return _this;
        // console.log('FormStretch - constructor - state.showHora: ', this.state.showHora)
        // console.log('FormStretch - constructor - props.fields: ', this.props.fields)
    }
    FormStretch.prototype.componentWillMount = function () {
        this.setState({
            values: this.parsedValues(),
            pricesValues: this.parsedPricesValues(this.props)
        }, function () {
            // console.log('state changed in componentWillMount')
        });
    };
    FormStretch.prototype.render = function () {
        var _this = this;
        console.log('FormStretch - render()');
        var _a = this.props, canBeDeleted = _a.delete, loading = _a.loading;
        var _b = this.state, values = _b.values, pricesValues = _b.pricesValues, showHora = _b.showHora;
        // console.log('FormStretch - render - this.props.values', this.props.values)
        // console.log('FormStretch - render - \'disabled\' in (this.props.values || {})', 'disabled' in (this.props.values || {}))
        var canBeDisabled = 'disabled' in (this.props.values || {});
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        return (React.createElement(Wrapper, null,
            this.fields.map(function (field) {
                if ((field.name === 'hora' && showHora) || field.name !== 'hora') {
                    return (React.createElement(Field, { key: field.name, field: __assign(__assign({}, field), { value: values[field.column ? field.column : field.name] || (values[field.column ? field.column : field.name] === 0 ? '0' : '') }), onChange: _this.handleChange }));
                }
                else
                    return null;
            }),
            React.createElement("div", { style: {
                    display: 'block',
                    marginLeft: '20px',
                    marginTop: '10px'
                } },
                React.createElement("label", { style: {
                        fontSize: 'large',
                        paddingTop: '100px',
                        marginLeft: '20px'
                    } }, T('pricesWithoutTax')),
                this.priceFields.length > 0 && React.createElement(WrapperPrices, null, this.priceFields.map(function (field) {
                    // console.log('field', field)
                    return (React.createElement(Field, { key: field.name, field: __assign(__assign({}, field), { value: pricesValues[field.name] || '' }), onChange: _this.handleChangePrices }));
                })),
                this.priceFields.length === 0 && (React.createElement("div", null, "No hay categor\u00EDas de pasajero, por favor a\u00F1ada categor\u00EDas de pasajero"))),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('cancel'))),
                this.props.values && canBeDisabled ? (this.props.values.disabled ? (React.createElement(StyledButton, { onClick: this.handleDisable(false) }, t('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, t('disable')))) : canBeDeleted ? (React.createElement(StyledButton, { onClick: this.handleDelete }, t('delete'))) : null,
                React.createElement(StyledButton, { onClick: this.handleReset }, t('reset')),
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    };
    FormStretch.prototype.parsedValues = function (props) {
        if (props === void 0) { props = this.props; }
        var values = props.values || {};
        // console.log('FormStretch - parsedValues - values: ', values)
        var result = this.fields.reduce(function (fields, field) {
            var _a;
            // console.log('FormStretch - field', field)
            // console.log('FormStretch - values[field.column? field.column: field.name]', values[field.column? field.column: field.name])
            return __assign(__assign({}, fields), (_a = {}, _a[field.column ? field.column : field.name] = values[field.column ? field.column : field.name] === undefined ? field.defaultValue : values[field.column ? field.column : field.name] ||
                (field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date ? new Date() : values[field.column ? field.column : field.name]), _a));
        }, {});
        // console.log('parsedValues - result', result)
        return result;
    }; /*
    antes de añadir prices
    private parsedValues(props: Props<P> = this.props) {
      const values = props.values || {}
  
      console.log('parsedValues: ', values)
      const result = this.fields.reduce(
        (fields, field) => ({
          ...fields,
          [field.name]:
          values[field.name] ||
          (field.type === FieldType.Select
            ? field.placeholder
              ? null
              : field.options && field.options[0] && field.options[0].value
            : field.type === FieldType.Date ? new Date() : values[field.name])
        }),
        {}
      )
      console.log('parsedValues - result', result)
      return result
    }*/
    FormStretch.prototype.parsedPricesValues = function (props) {
        if (props === void 0) { props = this.props; }
        var values = this.priceFields || [];
        // console.log('parsedPricesValues - this.priceFields: ', values)
        var result = values.reduce(function (fields, field) {
            var _a;
            // console.log('parsedPricesValues - field', field)
            return __assign(__assign({}, fields), (_a = {}, _a[field.name] = field.value ||
                (field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date ? new Date() : values[field.name]), _a));
        }, {});
        // console.log('parsedPricesValues - result', result)
        return result;
    };
    return FormStretch;
}(Component));
export default FormStretch;
var Wrapper = cxs('div')((_a = {
        paddingBottom: Theme.size.bar
    },
    _a[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        // paddingBottom: 0
    },
    _a));
var WrapperPrices = cxs('div')((_b = {
        paddingLeft: '20px'
    },
    _b[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        paddingBottom: 0
    },
    _b));
var ButtonsBar = cxs('div')((_c = {
        display: 'flex',
        width: '100%',
        position: 'absolute',
        bottom: 0,
        backgroundColor: Theme.color.background,
        zIndex: 1,
        borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
        '> button': {
            flex: 'auto',
            borderRight: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
            ':last-child': {
                borderWidth: 0
            }
        }
    },
    _c[mediaQueries.desktop] = {
        position: 'initial',
        marginTop: Theme.size.space[2],
        borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _c));
var StyledButton = cxs(Button)((_d = {
        flex: 2
    },
    _d[mediaQueries.desktop] = {
        padding: Theme.size.space[2]
    },
    _d));



//////////////////
// WEBPACK FOOTER
// ./src/components/FormStretch.tsx
// module id = 1055
// module chunks = 0